import { memo } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

function IconRefresh(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  return /*#__PURE__*/jsxs("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.22105 3.39347C5.41652 3.39347 3.1311 5.67381 3.1311 8.50013C3.1311 11.3265 5.41661 13.6075 8.22105 13.6075C11.0261 13.6075 13.311 11.3266 13.311 8.50013H14.4421C14.4421 11.9324 11.6636 14.7275 8.22105 14.7275C4.77916 14.7275 2 11.9324 2 8.50013C2 5.06779 4.77925 2.27347 8.22105 2.27347C9.94119 2.27347 11.4979 2.9728 12.6224 4.0995L11.8179 4.88676C10.8957 3.9628 9.62474 3.39347 8.22105 3.39347Z",
      fill: fill || '#1E1E23'
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6805 6.03565C12.4475 5.61262 12.1562 5.22607 11.8178 4.88665L12.6227 4.09975C13.0347 4.51299 13.3895 4.98378 13.6735 5.49941L12.6805 6.03565Z",
      fill: fill || '#1E1E23'
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6456 5.27336V2.50003H13.7767V6.39336H9.88443V5.27336H12.6456Z",
      fill: fill || '#1E1E23'
    })]
  });
}
var IconRefresh$1 = /*#__PURE__*/memo(IconRefresh);

export { IconRefresh$1 as default };
